/**
 * Created by esenckewitch on 19.03.2026
 *
 * https://developers.google.com/youtube/gaming/playables/reference/sdk#ytgame.ads
 */

const YoutubeAds = function () {
    AdsPlugin.call(this, connector.YOUTUBE, {
        cantLoadAndPlayInParallel: true
    });
};

YoutubeAds.prototype = Object.create(AdsPlugin.prototype);
YoutubeAds.prototype.constructor = YoutubeAds;

YoutubeAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.YOUTUBE);
};

YoutubeAds.prototype._connect = function (callback) {
    if (typeof ytgame !== "undefined" && ytgame.ads) {
        callback(connector.STATUS_CONNECTED);
    } else {
        callback(connector.STATUS_DISCONNECTED);
    }
};

YoutubeAds.prototype._cacheAd = function (name, callback) {
    callback(connector.CODE_SUCCEED, true);
};

YoutubeAds.prototype._playAd = function (name, ad, callback) {
    if (name === AdsPlugin.REWARDED) {
        this._playRewardedAd(callback);
    } else {
        this._playInterstitialAd(callback);
    }
};

YoutubeAds.prototype._playRewardedAd = function (callback) {
    ytgame.ads.requestRewardedAd("reward")
        .then((isRewardEarned) => {
            console.log("YoutubeAds rewarded finished, earned:", isRewardEarned);
            callback(isRewardEarned ? connector.CODE_SUCCEED : ERRORS.SHOW_REWARDED.CLOSED_BY_USER);
        })
        .catch((error) => {
            console.log("YoutubeAds rewarded error", error);
            callback(ERRORS.SHOW_REWARDED.UNKNOWN);
        });
};

YoutubeAds.prototype._playInterstitialAd = function (callback) {
    ytgame.ads.requestInterstitialAd()
        .then(() => {
            console.log("YoutubeAds interstitial finished");
            callback(connector.CODE_SUCCEED);
        })
        .catch((error) => {
            console.log("YoutubeAds interstitial error", error);
            callback(ERRORS.SHOW_INTERSTITIAL.UNKNOWN);
        });
};

YoutubeAds.prototype.isStickySupported = function () {
    return false;
};
